import React from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { CircleWavyCheck } from 'phosphor-react';

interface FinalizarProcessoModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Nome do processo, para o operador confirmar que é o card certo. */
  titulo?: string;
  isLoading?: boolean;
  onConfirm: () => void;
}

/** Confirmação do "Finalizar": o processo sai do quadro e vai para "Finalizados". */
export const FinalizarProcessoModal: React.FC<FinalizarProcessoModalProps> = ({
  isOpen,
  onClose,
  titulo,
  isLoading = false,
  onConfirm,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
    <ModalOverlay />
    <ModalContent borderRadius="xl">
      <ModalHeader display="flex" alignItems="center" gap={2} fontSize="18px" fontWeight="700">
        <CircleWavyCheck size={18} weight="duotone" />
        Finalizar processo
      </ModalHeader>
      <ModalCloseButton />

      <ModalBody>
        {titulo && (
          <Text fontSize="13px" fontWeight="700" color="gray.800" mb={1} noOfLines={2}>
            {titulo}
          </Text>
        )}
        <Text fontSize="13px" color="gray.600">
          O processo sai do quadro e vai para <b>Finalizados</b>, com a data e quem finalizou. Dá
          para reabrir de lá se precisar.
        </Text>
      </ModalBody>

      <ModalFooter gap={2}>
        <Button variant="ghost" onClick={onClose} isDisabled={isLoading}>
          Cancelar
        </Button>
        <Button
          leftIcon={<CircleWavyCheck size={15} weight="bold" />}
          onClick={onConfirm}
          isLoading={isLoading}
        >
          Finalizar
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
